<template>
    <auto-row class="wrap" mode="column">
        <auto-col>
            <head-nav @change="navChange"></head-nav>
        </auto-col>
        <auto-col class="page-top">
            <div class="banner-box" ref="eLocation">
                <img src="@/assets/image/aboutUs/04/00 banner.png" class="max-size" data-fit-cover alt=""  />
            </div>
        </auto-col>
        <auto-col style="background-color:#fff; border-bottom:1px solid #C7C7C7;">
            <location class="content-w" :data="currentNav.pathArr || []"></location>
        </auto-col>
        <auto-col  class="page-content" size="auto">
            <div class="x-w page-content-child">
                <div class="content-w">
                    <div class="page-content-box">
                        <div class="x-w-content">
                            <div class="title">新闻</div>
                            <auto-row class="max-size list flex-column">
                                    <auto-col class="list-item flex-items-start x-w-media" v-for="(item,index) of x_w_list" :key="index">
                                        <router-link  class="x-w-media" :to="{path:'/aboutUs/detail',query:{id:item.id}}">
                                        <img :src="item.icon" class="x-w-img max-size flex-none" data-fit-cover alt="">
                                        <div class="x-w-infos flex-1 pointer">
                                            <div class="titles text-line-s">{{item.title}}</div>
                                            <div class="flex items">
                                                <div class="item">发布时间：{{item.date}}</div>
                                                <div class="item">来源：{{item.orange}}</div>
                                            </div>
                                            <p class="text text-line-3">{{item.content}}</p>
                                            <div class="x-w-arrow">
                                                <img src="@/assets/image/aboutUs/04/gengduo02.png" class="x-w-arrow-img" height="22" alt="">
                                            </div>
                                        </div>
                                        </router-link>
                                    </auto-col>
                            </auto-row>
                        </div>
                    </div>
                </div>
            </div>
<!--            <div class="page-content-child"-->
<!--                v-for="(src,i) of imgArr"-->
<!--                :key="i"-->
<!--            >-->
<!--                <div class="content-w">-->
<!--                    <img :src="src" width="100%" alt="" />-->
<!--                </div>-->
<!--            </div>-->
        </auto-col>
        <auto-col>
            <form-box></form-box>
            <footer-box></footer-box>
            <fixed-box></fixed-box>
        </auto-col>
    </auto-row>
</template>

<script>
    import {
        autoRow,
        autoCol
    } from "@/components"
    import headNav from "@/components/headNav"
    import formBox from "@/components/formBox"
    import footerBox from "@/components/footerBox"
    import fixedBox from "@/components/fixedBox"
    import location from "@/components/location"
    import {
        methods
    } from "@/mixins"
    export default {
        name: '',
        components: {
            autoRow,
            autoCol,
            headNav,
            formBox,
            footerBox,
            fixedBox,
            location,
        },
        mixins:[methods],
        props: [],
        data() {
            return {
                currentNav:{},
                imgArr:[
                    require('@/assets/image/aboutUs/04/pic-1.png'),
                    require('@/assets/image/aboutUs/04/pic-2.png'),
                ],
                x_w_list:[
                    {
                        id:2,
                        title:'国务院关于印发“十四五”国家老龄事业发展和养老服务体系规划的通知',
                        content:'为实施积极应对人口老龄化国家战略，推动老龄事业和产业协同发展，构建和完善兜底性、普惠型、多样化的养老服务体系，不断满足老年人日益增长的多层次、高品质健康养老需求，根据《中华人民共和国老年人权益保障法》、《中华人民共和国国民经济和社会发展第十四个五年规划和2035年远景目标纲要》和《国家积极应对人口老龄化中长期规划》，制定本规划。',
                        date:'2021-12-30',
                        orange:'国务院',
                        icon:require('@/assets/image/aboutUs/04/pic.png')
                    },
                    {
                        id:5,
                        title:'民政部对“关于进一步加快推进居家养老服务体系建设的提案”的答复',
                        content:'关于鼓励社会力量参与发展养老服务、加大养老服务人才培训力度等建议针对性强，对于加强居家养老服务建设，构建居家社区机构相协调、医养康养相结合的养老服务体系具有很好的参考意义，我们将认真研究吸纳。',
                        date:'2021-12-03',
                        orange:'民政部网站',
                        icon:require('@/assets/image/aboutUs/04/pic.png')
                    },
                    {
                        id:1,
                        title:'国务院办公厅关于促进 养老托育服务健康发展的意见',
                        content:'各省、自治区、直辖市人民政府，国务院各部委、各直属机构：促进养老托育服务健康发展，有利于改善民生福祉，有利于促进家庭和谐，有利于培育经济发展新动能。为贯彻落实党中央、国务院决策部署，更好发挥各级政府作用，更充分激发社会力量活力，更好实现社会效益和经济效益相统一，持续提高人民群众的获得感、幸福感、安全感，经国务院同意，现提出以下意见。',
                        date:'2020-12-14',
                        orange:'国务院办公厅',
                        icon:require('@/assets/image/aboutUs/04/pic.png')
                    },
                    {
                        id:4,
                        title:'国务院办公厅关于推进养老服务发展的意见',
                        content:'党中央、国务院高度重视养老服务，党的十八大以来，出台了加快发展养老服务业、全面放开养老服务市场等政策措施，养老服务体系建设取得显著成效。但总的看，养老服务市场活力尚未充分激发，发展不平衡不充分、有效供给不足、服务质量不高等问题依然存在，人民群众养老服务需求尚未有效满足。',
                        date:'2019-03-29',
                        orange:'国务院办公厅',
                        icon:require('@/assets/image/aboutUs/04/pic.png')
                    },
                    {
                        id:3,
                        title:'国务院关于加快发展养老服务业的若干意见',
                        content:'近年来，我国养老服务业快速发展，以居家为基础、社区为依托、机构为支撑的养老服务体系初步建立，老年消费市场初步形成，老龄事业发展取得显著成就。但总体上看，养老服务和产品供给不足、市场发育不健全、城乡区域发展不平衡等问题还十分突出。当前，我国已经进入人口老龄化快速发展阶段，2012年底我国60周岁以上老年人口已达1.94亿，2020年将达到2.43亿，2025年将突破3亿。积极应对人口老龄化，加快发展养老服务业，不断满足老年人持续增长的养老服务需求，是全面建成小康社会的一项紧迫任务，有利于保障老年人权益，共享改革发展成果，有利于拉动消费、扩大就业，有利于保障和改善民生，促进社会和谐，推进经济社会持续健康发展。为加快发展养老服务业',
                        date:'2013-09-06',
                        orange:'国务院',
                        icon:require('@/assets/image/aboutUs/04/pic.png')
                    }
                ]
                // type: this.$route.params.pathMatch.replace("/",''),
            }
        },
        computed: { //计算属性

        },
        watch: {  //监听器

        },
        methods: {
            navChange(nav){
                this.currentNav = nav;
            }
        },
        created(){

        }, //组件实例创建完成，属性已绑定，但DOM还未生成，属性还不存在
        mounted(){
            this.$refs.eLocation && this.toScrollTop(this.$refs.eLocation.offsetTop);
        }, //模板编译/挂载之后(不保证组件已在document中)
        beforeRouteLeave(to, from, next) {
            next();
        },
//        beforeCreate(){}, //组件实例刚被创建，组件属性计算之前，如data属性等
//        beforeMount(){}, //模板编译/挂载之前
//        beforeUpdate(){}, //组件更新之前
//        updated(){}, //组件更新之后
//        activated(){}, //for keep-alive,组件被激活时调用
//        deactivated(){}, //for keep-alive,组件被激活时调用
//        beforeDestory(){}, //组件销毁前调用
//        destoryed(){}, //组件销毁后调用
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .wrap{
        background-color:#f0f2f5;
        min-height:100vh;
    }
    .banner-box{
        position:relative;
    }
    .banner-box img{
        width:100%;
        max-height:600px;
        min-height:200px;
        overflow:hidden;
        vertical-align: middle;
    }
    .page-content{
        position: relative;
        z-index:2;
    }
    .page-content-child:nth-child(1){
        background-color: #FFFFFF;
    }

    .page-content-child .title:nth-child(1){
        color:#333333;
        font-size: 36px;
        line-height: 1;
        letter-spacing: 16px;
    }

    .page-content-box{
        overflow:hidden;
    }

    .x-w .x-w-content{
        text-align: center;
        padding:102px 0 53px 0;
    }
    .x-w .list{
        padding:0 5px;
    }

    .list-item{
        transition: all .3s;
        padding:50px 50px;
        position: relative;
    }

    .x-w-media{
        display: flex;
    }

    .list-item:nth-child(1){
        margin-top: 65px;
    }

    .x-w .list-item:hover{
        transform: translateY(-5px);
        background: #F9F9F9;
        box-shadow: 0px 2px 13px 0px rgba(0,0,0,0.14);
    }

    .x-w-img{
        max-width: 340px;
        max-height:238px;
        min-height: 100px;
        width: 100%;
        overflow:hidden;
        vertical-align: middle;
        background: #D8D8D8;
        border: 1px solid #979797;
    }

    .x-w-infos{
        text-align: left;
        margin-left:32px;
        padding-right:90px;
        position: relative;
    }

    .x-w-infos .x-w-arrow{
        position: absolute;
        top:0;
        bottom:0;
        margin: auto 0;
        right:0px;
        width: 40px;
        height: 56px;
        background: #2FA8D0;
    }

    .x-w-infos .x-w-arrow .x-w-arrow-img{
        position: absolute;
        left: 0;
        top: 0;
        right: 0;
        bottom: 0;
        margin: auto;
    }

    .x-w-arrow:hover{
        opacity: .9;

    }

    .x-w-infos .titles{
        font-size: 24px;
        font-weight: 400;
        color: #333333;
        /*line-height: 1;*/
        padding-top:18px;
    }

    .x-w-infos .items{
        font-size: 20px;
        font-weight: 400;
        color: #888888;
        line-height: 1;
        padding-top:18px;
    }

    .x-w-infos .items .item{
        width: 50%;
        text-align: left;
    }

    .x-w-infos .text{
        font-size: 20px;
        font-weight: 400;
        color: #333333;
        line-height: 36px;
        padding-top:24px;
    }

    /*.text-line-hidden{*/
    /*    width: 100;*/
    /*    overflow: hidden;*/
    /*    text-overflow:ellipsis;*/
    /*    white-space: nowrap;*/
    /*}*/


    /*适配不同尺寸*/
    @media screen and (max-width: 1540px){


    }

    @media screen and (max-width: 1200px){
        .x-w-media{
            display: flex;
            flex-flow: column nowrap!important;
            align-items:flex-start!important;
        }

        .list-item{
            transition: all .3s;
            padding:40px 40px;
            position: relative;
        }

        .list-item:nth-child(1){
            margin-top: 55px;
        }

        .x-w-img{
            max-width: 100%;
            height: 100%;
            background: #D8D8D8;
            border: 1px solid #979797;
        }

        .x-w-infos{
            text-align: left;
            margin-left:0!important;
            padding-right:90px;
        }

        .x-w-infos{
            text-align: left;
            margin-left:32px;
            padding-right:50px;
            position: relative;
        }

        .x-w-infos .x-w-arrow{
            position: absolute;
            top:0;
            bottom:0;
            margin: auto 0;
            right:0px;
            width: 40px;
            height: 56px;
            background: #2FA8D0;
        }

    }

    @media screen and (max-width: 960px){
        .x-w .x-w-content{
            text-align: center;
            padding:50px 0 45px 0;
        }
        .list-item{
            transition: all .3s;
            padding:30px 30px;
            position: relative;
        }

        .list-item:nth-child(1){
            margin-top: 55px;
        }
    }

    @media screen and (max-width: 760px){

        .x-w .x-w-content{
            text-align: center;
            padding:40px 0 45px 0;
        }

        .list-item{
            transition: all .3s;
            padding:20px 20px;
            position: relative;
        }

        .list-item:nth-child(1){
            margin-top: 25px;
        }

        .x-w-infos .items{
            font-size: 20px;
            font-weight: 400;
            color: #888888;
            line-height: 1;
            padding-top:18px;
            display: flex;
            flex-flow: column nowrap;
        }

        .x-w-infos .items .item{
            width: 100%;
            text-align: left;
        }

        .x-w-infos .items .item:last-child{
            padding-top:10px;
        }
    }
</style>
